import React from "react";
import Lottie from "web/react/components/lottie/lottie";
import animationData from "./loading-spinner.json";

function LoadingSpinnerAnimation(): JSX.Element {
    return <Lottie animationData={animationData} loop />;
}

export default LoadingSpinnerAnimation;
